import { render, staticRenderFns } from "./config.vue?vue&type=template&id=19d37775"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d37775')) {
      api.createRecord('19d37775', component.options)
    } else {
      api.reload('19d37775', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=19d37775", function () {
      api.rerender('19d37775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/5-2-nav-bar-2/config.vue"
export default component.exports